// src/components/spatial/utils/drawIds.js

const padNumber = (value, size = 3) => {
  const stringValue = String(value ?? "");
  if (stringValue.length >= size) return stringValue;
  return `${"0".repeat(size - stringValue.length)}${stringValue}`;
};

export const createDrawId = (prefix = "obj") => {
  const randomPart = Math.random().toString(36).slice(2, 8);
  const timePart = Date.now().toString(36);
  return `${prefix}_${timePart}_${randomPart}`;
};

export const createFloorId = () => {
  return createDrawId("floor");
};

export const createEntityId = () => {
  return createDrawId("ent");
};

export const createViewCode = (order = 1) => {
  return `LVL-${padNumber(order, 2)}`;
};